export const customSolutions = {
  hero: {
    title: 'Custom Solutions for Your Business',
    subtitle: 'Every business is unique. We design and develop tailor-made solutions that perfectly adapt to your processes and specific needs.'
  },
  intro: {
    title: 'More Than Standard Solutions',
    description: 'If your business has specific requirements that go beyond our standard services, we are here to help. We work with you to design, develop, and implement custom solutions that drive your growth.'
  },
  process: {
    title: 'Our Process',
    steps: [
      {
        title: 'Business Diagnosis',
        description: 'We deeply analyze your business, processes, and needs. We identify automation opportunities and define clear objectives.'
      },
      {
        title: 'Custom Design',
        description: 'We create a tailor-made solution adapted to your workflows. We design the architecture and functionalities you need.'
      },
      {
        title: 'Implementation and Support',
        description: 'We develop and deploy the solution with full support. Training for your team and continuous optimization.'
      }
    ]
  },
  cta: {
    title: 'Let\'s Talk About Your Project',
    subtitle: 'Tell us what you need and we will design the perfect solution for your business'
  }
};
